var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.434,
    height: 45.358,
    viewBox: "0 0 59.434 45.358",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M57.524,47.356H5.91A3.915,3.915,0,0,1,2,43.446V3.568c0-.033,0-.067,0-.1v0a1.561,1.561,0,0,1,.34-.881c.028-.034.057-.068.088-.1A1.562,1.562,0,0,1,3.541,2H59.892A1.557,1.557,0,0,1,61,2.485c.031.032.06.066.088.1a1.557,1.557,0,0,1,.341.881v0c0,.033,0,.067,0,.1V43.446a3.915,3.915,0,0,1-3.91,3.91M7.586,44.228H55.849L36.835,26.8l-4.061,3.723a1.565,1.565,0,0,1-2.114,0L26.6,26.8ZM5.128,7.119V42.238l19.156-17.56ZM39.15,24.678,58.306,42.237V7.119ZM27.675,23.543l4.042,3.706,4.038-3.7.051-.047L55.849,5.127H7.585L27.633,23.5l.041.038",
    transform: "translate(-2 -1.999)",
    fill: "#de1a28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.715c6bdaa150f9004179ae46c3723e17.svg";
export { ForwardRef as ReactComponent };